import * as types from '../actions/action-types';

const INITIAL_STATE = {
    currentlyAssignedTo: [],
    reassignTo: [],
    counter: 0,
    successSubmission: false,
    reassignSubmitLoading: false,
    assignedData: {
        events: [],
        reports: [],
        tasks: []
    },
    assignedDataLoading: false
};
export const getCurrentlyAssignedTo = state => state.currentlyAssignedTo;
export const getAssignedData = state => state.assignedData;
export const getAssignedDataLoading = state => state.assignedDataLoading;
export const getReassignSubmitLoading = state => state.reassignSubmitLoading;
export const getCounter = state => state.counter;
export const getSuccessSubmission = state => state.successSubmission;
export const getReassignTo = state => state.reassignTo;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_LOADING) {
        return {
            ...state,
            assignedDataLoading: !state.assignedDataLoading
        };
    } else if (action.type === types.FETCH_CURRENTLY_ASSIGNED_TO_SUCCESS) {
        return {
            ...state,
            currentlyAssignedTo: action.payload
        };
    } else if (action.type === types.COUNTER_SUCCESS) {
        return {
            ...state,
            counter: action.count
        };
    } else if (
        action.type === types.FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_SUCCESS
    ) {
        return {
            ...state,
            assignedData: action.data
        };
    } else if (action.type === types.FETCH_REASSIGNED_TO_SUCCESS) {
        return {
            ...state,
            reassignTo: action.data
        };
    } else if (action.type === types.SUBMISSION_REASSIGN_EVENTS_SUCCESS) {
        return {
            ...state,
            successSubmission: true
        };
    } else if (action.type === types.REMOVE_SUBMISSION_BANNER) {
        return {
            ...state,
            successSubmission: false
        };
    } else if (action.type === types.REASSIGN_SUBMIT_LOADING) {
        return {
            ...state,
            reassignSubmitLoading: !state.reassignSubmitLoading
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/admin.js